import { createRESTContract } from '../../index';
import { DataSourceDetailsSchema } from '../data-sources/data-sources.schema';
import { SyncBodySchema } from '../data-sources/sync.schema';

export const rompslompContract = createRESTContract({
  syncKnowledgeArticles: {
    method: 'POST',
    path: '/rompslomp/knowledge-articles/sync',
    permissions: [],
    body: SyncBodySchema,
    response: DataSourceDetailsSchema,
  },
});
